// extracted by mini-css-extract-plugin
export default {"base-btn":"Button_base-btn__xDw7D","btn-gradient":"Button_btn-gradient__OREIA","btn-gradient-outline":"Button_btn-gradient-outline__AWHDs"};